module.exports = __webpack_public_path__ + "img/lexus.62a3bd30.png";